import { ACTION_TYPE as USER_ACTION } from '../actions/user';
import moment from 'moment';

export enum STORAGE_KEY {
  USER = 'user',
  ROLE = 'role',
}

export const storage = (key: string, { payload }: any) => {
  if (payload) {
    if (!payload.data) {
      return;
    }

    payload.data = {
      ...payload.data,
      login_time: moment().format('YYYY-MM-DD HH:mm:ss'),
    };

    try {
      localStorage.setItem(key, JSON.stringify(payload.data));
    } catch (error) {
      console.error(error);
    }
  }
};

export const clear = (key: string) => {
  return localStorage.removeItem(key);
};

export const storageMiddleware = (store: any) => (next: any) => (action: any) => {
  switch (action.type) {
    case USER_ACTION.LOGIN:
      storage(STORAGE_KEY.USER, action);
      break;
    case USER_ACTION.LOGOUT:
      setTimeout(
        () => clear(STORAGE_KEY.USER), 1000
      )
      break;
    default:
  }
  return next(action);
};